import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";

export const EMPTY_LUNCH_OPTION = {value: -1, label: "N/A"};

export const getLunchOption = (lunch_option, lunchOptions) =>
{
    if (lunch_option !== -1)
    {
        return lunchOptions.find((item) =>
            item.value === lunch_option
        )
    }
    else
    {
        return EMPTY_LUNCH_OPTION;
    }

}

export const getLunchOptions = (lunchOptions) =>
{
    const options = lunchOptions.map((item) =>
    {
        return {value: item.id, label: item.lunch_description}
    })

    return [...options, EMPTY_LUNCH_OPTION];
}

const DropdownLunchOption = ({control, fieldName, lunchOptions, lunch_option}) =>
{
    return <CommonDropdown items={lunchOptions} control={control} name={fieldName}/>
}

export default DropdownLunchOption;